
export class Settings {
    public static readonly DefaultTitle: string = "Futuris View";
    public static readonly ErrorTimeout: number = 5000;
    
    public static readonly ApiEndPointProduction: string = "/system/api.php";
    public static readonly ApiEndPointDebug: string = "https://fview.denr01.com/system/api.php";

    public static readonly PeriodMaxDays: number = 31 * 3;
}
